// eslint-disable-next-line import/prefer-default-export
export const getBaseUrl = () => {
    if (window.location.host === 'localhost') return 'localhost';
    const getUrlParam = function (param) {
        const codedParam = new RegExp(`${param}=([^&]*)`).exec(window.location.search)[1];
        return decodeURIComponent(codedParam);
    };
    return new Promise((res, _rej) => {
        if (!window.AP) {
            res(getUrlParam('xdm_e') + getUrlParam('cp'));
        }
        window.AP.getLocation(function (location) {
            const baseUrl = new URL(location).origin;
            res(baseUrl);
        });
    });
};
